import { render, staticRenderFns } from "./PostingCategoryItem.vue?vue&type=template&id=65042106&scoped=true&"
import script from "./PostingCategoryItem.vue?vue&type=script&lang=js&"
export * from "./PostingCategoryItem.vue?vue&type=script&lang=js&"
import style0 from "./PostingCategoryItem.vue?vue&type=style&index=0&id=65042106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65042106",
  null
  
)

export default component.exports